<template>
	<div class="text-center">
		<v-dialog
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="edit-note-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="edit-note-modal__card">
				<div class="d-flex mb-4 align-center flex-wrap">
					<div class="edit-note-modal__title">
						{{ edit ? 'Edit' : 'Add' }} Note About {{ username }}
					</div>
				</div>

				<NoteTextForm
					v-on:closeModal="closeModal"
					:id="id"
					:note="note"
					:edit="edit"
					:userPage="userPage"
				/>
				<v-btn
					icon
					class="edit-note-modal__button-close"
					style="background-color: #fff !important;"
					@click="closeModal"
				>
					<v-icon color="#0055A3">mdi-close</v-icon>
				</v-btn>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NoteTextForm from '@/components/Forms/NoteTextForm.vue'
export default {
	components: { NoteTextForm },

	props: ['show', 'id', 'note', 'edit', 'username', 'userPage'],

	data: () => ({
		tab: null,
	}),

	methods: {
		...mapActions('chats', ['deleteMessage']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),

		closeModal() {
			this.$emit('closeModal')
		}
	},

	computed: {
		...mapGetters('settings', ['chaptersList']),
		...mapGetters('post', ['isFileLoading', 'postFile']),
		...mapGetters('tag', ['tags']),
	},

	created() {
		//
	},
}
</script>

<style lang="scss">
.edit-note-modal {
	border-radius: 10px;

	&__card {
		padding: 30px;
	}
	&__title {
		color: var(--accent-color);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}
	&__time {
		color: rgb(74, 74, 74);
		font-size: 12px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		letter-spacing: -0.29px;
		padding: 10px 0;
	}
	&__tabs-wrapper {
		padding-bottom: 10px;

		.v-slide-group__wrapper {
			border-bottom: 1px solid rgb(219, 219, 219);
		}
	}
	&__button-close {
		position: absolute;
		top: 20px;
		right: 20px;
		background-color: #fff !important;
	}
}
</style>
